import {Injectable} from "@angular/core";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private _snackBar: MatSnackBar) {
  }

  public log(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
    })
  }

  public logInfo(message: string) {
    this._snackBar.open(message, 'Закрыть', {
      horizontalPosition: "center",
      verticalPosition: "top",
    })
    MatSnackBarConfig
  }
}
